import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import { MODULE_PURCHASE_ORDER } from "variables/constants";
import Leaves from "./index";
import ViewPurchaseOrder from "./view";
import EditPurchaseOrder from "./edit";
import { ShoppingBag } from "lucide-react";

const purchaseOrderRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Purchase Orders",
		basePath: "purchase-orders",
		mainComponent: <Leaves />,
	    layout: "/console",	   
	    icon: <ShoppingBag className="icon-item" />,
	    subTitle:"Purchase Orders",
	    viewComponent: <ViewPurchaseOrder />,
	    createComponent: <EditPurchaseOrder />,
	    editComponent: <EditPurchaseOrder />,
		level:3,
		moduleId: MODULE_PURCHASE_ORDER,
	})
]

export default purchaseOrderRoutes;